import React, { Component } from 'react';
import PhotoCardsSwiper from "../components/PhotoCardsSwiper";
import { Link } from "react-router-dom";

const cardImages = [
  "images/Blog/cardinoiluminado1.jpg",
  "images/Blog/cardinoiluminado2.jpg",
  "images/Blog/cardinoiluminado3.jpg",
  "images/Blog/cardinoiluminado4.jpg",
  "images/Blog/cardinoiluminado5.jpg",
  "images/Blog/cardinoiluminado6.jpg",
  "images/Blog/cardinoiluminado7.jpg",
  "images/Blog/cardinoiluminado8.jpg"
];

class DinoIluminadoBlog extends Component {
  componentDidMount() {
  if (window.startx) {
    window.startx();
  }
}

  render() {
    return (
      <div id="main" className="wrapper style1">
        <div className="container">
          <header className="major">
            <h2>Dinoparque Iluminado</h2>
          </header>
          <div className="containerimagenblog">
            <img className="imagenBlog" src="images/Blog/dinoiluminadoportada.jpg" alt="Dinoparque Iluminado" />
          </div>
          <div className="containerblog">
            <div className="align justify">
              <p>
                El Dinoparque Iluminado fue una experiencia única que transformó nuestro Dinoparque en un escenario lleno de 
                luz, fantasía y emoción, invitando a chicos y grandes a vivir un recorrido nocturno inolvidable entre dinosaurios, 
                nieve y personajes muy especiales. Durante este recorrido especial, los visitantes pudieron explorar el Dinoparque 
                bajo una atmósfera completamente distinta, donde la iluminación, la música y los efectos crearon un ambiente mágico 
                que hizo brillar cada rincón del parque. 
                </p>
                <p>
                Las familias disfrutaron de múltiples actividades pensadas para sorprender, divertir y crear recuerdos memorables:
                </p>
              <ul>
                <li>
                  <strong>
                    <span role="img" aria-label="Cámara fotográfica">📸</span> Spots de Fotos
                  </strong>
                  <br />
                  Espacios especialmente diseñados para capturar momentos únicos.
                </li>

                <li>
                  <strong>
                    <span role="img" aria-label="Patinaje sobre hielo">⛸️</span> Pista de Hielo
                  </strong>
                  <br />
                  Una de las actividades favoritas, donde niños y adultos se divirtieron
                  patinando y sintiendo el espíritu invernal.
                </li>

                <li>
                  <strong>
                    <span role="img" aria-label="Nieve">❄️</span> Nieve en el Dinoparque
                  </strong>
                  <br />
                  La emoción de ver y jugar con nieve convirtió al Dinoparque en un verdadero
                  paisaje mágico, ideal para disfrutar en familia.
                </li>

                <li>
                  <strong>
                    <span role="img" aria-label="Tren turístico">🚂</span> Recorrido en Tren
                  </strong>
                  <br />
                  Un paseo lleno de encanto que permitió recorrer el Dinoparque de una forma
                  diferente, admirando cada detalle iluminado del evento.
                </li>

                <li>
                  <strong>
                  <span role="img" aria-label="Dinosaurio">🦕</span> Dinosaurios Mecatrónicos
                </strong>
                <br />
                Los imponentes dinosaurios cobraron vida con movimientos y sonidos,
                sorprendiendo a los visitantes durante todo el recorrido nocturno.
              </li>
            </ul>

              <p>
                La magia se hizo aún más especial con la presencia de personajes entrañables que emocionaron a niñas y niños: <strong>Santa 
                  Claus</strong>, llevando alegría y sonrisas a cada encuentro. <strong>El Grinch</strong>, quien con su carisma y travesuras se 
                  convirtió en uno de los favoritos para fotos. <strong>Los Reyes Magos</strong>, llenando el Dinoparque de ilusión y tradición, marcando 
                  un momento muy especial para las familias.
              </p>
              <p>
                El Dinoparque Iluminado fue mucho más que un evento: fue una experiencia llena de luz, emoción y momentos compartidos que quedarán en 
                la memoria de todos los asistentes. Agradecemos a cada familia que formó parte de esta aventura nocturna y ayudó a hacerla tan especial.
              </p>
              
            </div>
           
            <div>
              {/*  GALERÍA */}
              <h3 className='section-title'>Momentos Destacados</h3>
              <PhotoCardsSwiper images={cardImages} />

              <div className="containerjuego">
               <Link className="button" to="/blog">
                Regresar
              </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DinoIluminadoBlog;